export function getToken() {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
}

export function salvarToken(token, manterConectado) {
  limparToken();

  if (manterConectado) {
    localStorage.setItem("token", token);
  } else {
    sessionStorage.setItem("token", token);
  }
}

export function limparToken() {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
}

export function estaLogado() {
  return !!getToken();
}